'use strict'

var Marionette = require('marionette')
var App = require('app')

/* Views */
var show = require('./show')

var PageLogin = function () {
  /* Routes ----------------------------------------------------------------- */
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
      'login': 'show'
    }
  })

  /* API -------------------------------------------------------------------- */
  var API = {
    show: function () {
      new show()
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('login:show', function (options) {
    API.show()
  })

  new Router({ controller: API })
}

module.exports = PageLogin



// WEBPACK FOOTER //
// ./js/modules/page-login/index.js